<template>
  <div class="launch">
    <div class="launchBlock">
      <p style="font-size: 24px; font-weight: bold">Create new Token</p>
      <div class="tokenInfo">
        <div class="tokenText">
          <p>Name</p>
          <div class="input">
            <input placeholder="example: Nick Fury" v-model="name" size="small" />
          </div>
          <p>Symbol</p>
          <div class="input">
            <input placeholder="example: DNT" v-model="symbol" size="small" />
          </div>
          <p>Description</p>
          <div class="input">
            <input placeholder="example: S.H.I.E.L.D. owner" v-model="description" size="small" />
          </div>
          <p>Website</p>
          <div class="input">
            <input placeholder="example: https://google.com" v-model="website" size="small" />
          </div>
          <p>Telegram</p>
          <div class="input">
            <input placeholder="example: https://t.me/tttttttt" v-model="telegram" size="small" />
          </div>
          <p>X.com</p>
          <div class="input">
            <input placeholder="example: https://x.com/tqtwtqwtqwt" v-model="twitter" size="small" />
          </div>
          <p>Dev Wallet SOL Amount</p>
          <div class="input">
            <input placeholder="example: 0.1" v-model="devSolAmount" size="small" :step="0.001" :min="0.000001" />
          </div>

          <div class="payer-block">
              <p>Payer ID <a :href="`https://solscan.io/account/${this.payerPublicKey}`" class="payer-solscan">solscan</a></p>
              <select v-model="payerID">
                <option v-for="i of payers" :key="i" :value="i.id">{{ i.publicKey }}</option>
              </select>
              <button class="button" @click="createNewPayer">Create New Payer</button>
          </div>

        </div>
        <div class="imageToken">
          <!-- <img width="150" height="150" src="../assets/logo.png"/> -->
          <div class="upload_photo" @click="selectFile">
            <span>Upload photo</span>
            <input @change="onFileChange" type="file" class="upload_input" accept="image/*" />
          </div>
          <div v-if="imageSrc" class="preview">
            <img :src="imageSrc" alt="Preview" style="width: 100px" />
          </div>
          <!-- <n-upload accept="image/*" list-type="image-card" max="1" :custom-request="handleUpload"> Click to Upload </n-upload> -->
        </div>
      </div>
      <div class="zeroblock">
        <p>Zeroblock Wallets</p>
        <div class="zeroblock-wallets-config">
          <div class="input">
            <input placeholder="example: 0.1" v-model="zb_wallet_1" size="small" />
          </div>      
          <div class="input">
            <input placeholder="example: 0.1" v-model="zb_wallet_2" size="small" />
          </div>      
          <div class="input">
            <input placeholder="example: 0.1" v-model="zb_wallet_3" size="small" />
          </div>
        </div>
      </div>

      <div class="pro_traders">
        <p>Pro Traders</p>
        <div class="protrades-wallets-config">
          <img style="width: 1em; height: 1em;" src="../assets/axiom_wallet_logo.png"/>
          <div class="input">
            <input placeholder="example: 30" v-model="axiomTradersPercent" size="small" />
          </div>
          <img style="width: 1em; height: 1em;" src="../assets/bullx_wallet_logo.png"/>      
          <div class="input">
            <input placeholder="example: 30" v-model="bullxTradersPercent" size="small" />
          </div>      
          <img style="width: 1em; height: 1em;" src="../assets/photonLogo.svg"/>    
          <div class="input">
            <input placeholder="example: 30" v-model="photonTradersPercent" size="small" />
          </div>

          <img style="width: 1em; height: 1em;" src="../assets/terminal.png"/>    
          <div class="input">
            <input placeholder="example: 30" v-model="padreTradersPercent" size="small" />
          </div>
          <img style="width: 1em; height: 1em;" src="../assets/gmgn.png"/>    
          <div class="input">
            <input placeholder="example: 30" v-model="gmgnTradersPercent" size="small" />
          </div>
        </div>
      </div>
      <div class="switch-container">
        <p>Heated Dev</p>
        <label class="ios-switch">
          <input type="checkbox" v-model="heatedDev" />
          <span class="slider"></span>
        </label>
      </div>
      <div class="switch-container">
        <p>Cashback</p>
        <label class="ios-switch">
          <input type="checkbox" v-model="is_cashback" />
          <span class="slider"></span>
        </label>
      </div>
      <button class="button" @click="createToken">Save</button>

      <p>Fast Launch Wallets Count</p>
      <div class="input">
        <input placeholder="example: 0.1" v-model="fast_launch_wallets_count" size="small" />
      </div>
      <button class="button" @click="fastLaunch">Fast Launch</button>

      <p>Copy token metadata</p>
      <div class="input">
        <input placeholder="example: 0.1" v-model="copy_token_pk" size="small" />
      </div>
      <button class="button" @click="fetchTokenData">Copy</button>
    </div>
  </div>
</template>

<script>
  import { RPC_ENDPOINT } from "@/services/solanaClient";
import { PublicKey } from "@solana/web3.js";
import axios from "axios"
  import { ref } from "vue"
  import { useToast } from "vue-toastification"

  const PRO_TRADERS_STORAGE_KEY = "createToken.proTradersPercent"

  function loadProTradersPercent() {
    try {
      return JSON.parse(localStorage.getItem(PRO_TRADERS_STORAGE_KEY)) || {}
    } catch {
      return {}
    }
  }

  export default {
    name: "CreateToken",
    data() {
      const savedProTraders = loadProTradersPercent()
      return {
        name: "",
        symbol: "",
        description: "",
        website: "",
        telegram: "",
        twitter: "",
        copy_token_pk: "",
        zb_wallet_1: null,
        zb_wallet_2: null,
        zb_wallet_3: null,
        photonTradersPercent: savedProTraders.photonTradersPercent ?? 20,
        axiomTradersPercent: savedProTraders.axiomTradersPercent ?? 20,
        bullxTradersPercent: savedProTraders.bullxTradersPercent ?? 20,
        padreTradersPercent: savedProTraders.padreTradersPercent ?? 20,
        gmgnTradersPercent: savedProTraders.gmgnTradersPercent ?? 20,
        heatedDev: false,
        is_cashback: false,
        fast_launch_wallets_count: 15,
        devSolAmount: 0.001,
        payerID: {},
        payerPublicKey: null,
        payers: [
          {
            label: "ffasf",
            key: 123,
          },
        ],
        createFileSend: null,
        imageSrc: null,
      }
    },
    computed: {
      proTradersPercent() {
        return {
          photonTradersPercent: this.photonTradersPercent,
          axiomTradersPercent: this.axiomTradersPercent,
          bullxTradersPercent: this.bullxTradersPercent,
          padreTradersPercent: this.padreTradersPercent,
          gmgnTradersPercent: this.gmgnTradersPercent,
        }
      },
    },
    watch: {
      proTradersPercent(value) {
        localStorage.setItem(PRO_TRADERS_STORAGE_KEY, JSON.stringify(value))
      },
    },
    methods: {
      createToken() {
        console.log(this.$store.getters.getUserData)
        if (this.name.length == 0 || this.symbol.length == 0 || this.payerID.length == 0) {
          if (this.file == null) this.toast.error("Please upload image", { timeout: 2000 })
          else this.toast.error("Please fill all fields", { timeout: 2000 })
        } else {
          const formData = new FormData()
          formData.append("name", this.name)
          formData.append("symbol", this.symbol)
          formData.append("description", this.description)
          this.website && formData.append("website", this.website)
          this.telegram && formData.append("telegram", this.telegram)
          this.twitter && formData.append("twitter", this.twitter)

          formData.append("photonTradersPercent", this.photonTradersPercent)
          formData.append("axiomTradersPercent", this.axiomTradersPercent)
          formData.append("bullxTradersPercent", this.bullxTradersPercent)
          formData.append("padreTradersPercent", this.padreTradersPercent)
          formData.append("gmgnTradersPercent", this.gmgnTradersPercent)
          formData.append("heatedDev", this.heatedDev)
          formData.append("is_cashback", this.is_cashback)
          formData.append("devSolAmount", this.devSolAmount)
          formData.append("payerId", this.payerID)
          formData.append("file", this.createFileSend)

          
          const wallets = [
            this.zb_wallet_1,
            this.zb_wallet_2,
            this.zb_wallet_3
          ]
            .filter(v => v != null && Number(v))
            .map(v => ({ solAmount: v }));

          if (wallets.length > 0) {
            formData.append('zeroblockWallets', JSON.stringify(wallets));
          }

          axios
            .post(`${process.env.VUE_APP_SERVERHOST}/api/token/create`, formData, {
              headers: {
                Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
              },
            })
            .then((res) => {
              console.log(res)
              this.toast.success(res.data.message, { timeout: 2000 })
            })
            .catch((err) => {
              console.log(err)
              this.toast.error(err.response.data.message, { timeout: 2000 })
            })
        }
      },
      fastLaunch () {
                console.log(this.$store.getters.getUserData)
        if (this.name.length == 0 || this.symbol.length == 0 || this.payerID.length == 0) {
          if (this.file == null) this.toast.error("Please upload image", { timeout: 2000 })
          else this.toast.error("Please fill all fields", { timeout: 2000 })
        } else {
          const formData = new FormData()
          formData.append("name", this.name)
          formData.append("symbol", this.symbol)
          formData.append("description", this.description)

          this.website && formData.append("website", this.website)
          this.telegram && formData.append("telegram", this.telegram)
          this.twitter && formData.append("twitter", this.twitter)

          formData.append("photonTradersPercent", this.photonTradersPercent)
          formData.append("axiomTradersPercent", this.axiomTradersPercent)
          formData.append("bullxTradersPercent", this.bullxTradersPercent)
          formData.append("padreTradersPercent", this.padreTradersPercent)
          formData.append("gmgnTradersPercent", this.gmgnTradersPercent)
          formData.append("heatedDev", this.heatedDev)
          formData.append("is_cashback", this.is_cashback)

          formData.append("devSolAmount", this.devSolAmount)
          formData.append("payerId", this.payerID)
          formData.append("file", this.createFileSend)
          formData.append("fastLaunchWalletsCount", this.fast_launch_wallets_count)
        
          const wallets = [
            this.zb_wallet_1,
            this.zb_wallet_2,
            this.zb_wallet_3
          ]
            .filter(v => v != null && Number(v))
            .map(v => ({ solAmount: v }));

          if (wallets.length > 0) {
            formData.append('zeroblockWallets', JSON.stringify(wallets));
          }



          axios
            .post(`${process.env.VUE_APP_SERVERHOST}/api/token/create-and-launch`, formData, {
              headers: {
                Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
              },
            })
            .then((res) => {
              console.log(res)
              this.toast.success(res.data.message, { timeout: 2000 })
              this.$store.commit("setSelectedToken", res.data);
            })
            .catch((err) => {
              console.log(err)
              this.toast.error(err.response.data.message, { timeout: 2000 })
            })
        }
      },
      async urlToFile(url) {
        const res = await axios.get(url, { responseType: "blob",            
         headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
          } 
        });
        const blob = res.data;
        console.log("res", res.data)
        return new File([blob], "token.png", { type: blob.type || "image/png" });
      },
    async fetchTokenData () {
      const mint = new PublicKey(this.copy_token_pk);
      if(!this.copy_token_pk) return
        const { data } = await axios.post(RPC_ENDPOINT, {
          jsonrpc: "2.0",
          id: "1",
          method: "getAsset",
          params: { id: mint },
        });

      //const { json_uri } = data?.result.content;
      const content = data?.result.content;
        //console.log(data.result)
      if (content) {
        try {
          this.name = content.metadata.name
          this.symbol = content.metadata.symbol
          this.description = content.metadata.description
          this.imageSrc = content.links?.image
          if (this.imageSrc) { 
            try {
              this.createFileSend = await this.urlToFile(`${process.env.VUE_APP_SERVERHOST}/api/token/get-image?json_uri=${encodeURIComponent(this.imageSrc)}` ) 
            } catch (error) { console.log(error) }

          }
          
          const res = await axios.get(`${process.env.VUE_APP_SERVERHOST}/api/token/get-asset?json_uri=${encodeURIComponent(content.json_uri)}`, {

                          headers: {
                Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
              },

          })

          this.twitter = res.data?.twitter
          this.telegram = res.data?.telegram
          this.website = res.data?.website
        } catch (error) {
          console.log(error)
        }
      }
      return 1
    },  
      selectPayer(id) {
        this.payerId = id
        this.payerPublicKey = this.payers.find(obj => obj.id === id).publicKey
      },
      selectFile() {
        document.querySelector(".upload_input").click()
      },
      onFileChange(event) {
        const file = event.target.files[0]
        this.createFileSend = file
        this.imageSrc = URL.createObjectURL(file)
        console.log("Выбран файл", file)
      },
      getPayers() {
        axios
          .get(`${process.env.VUE_APP_SERVERHOST}/api/wallet/payers`, {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          })
          .then((res) => {
            this.payers = res.data
            this.payerID = this.payers[this.payers.length - 1].id
            this.payerPublicKey = this.payers[this.payers.length - 1].publicKey
          })
          .catch((err) => {
            console.log(err)
          })
      },
      async createNewPayer () {
        const res = await axios.post(`${process.env.VUE_APP_SERVERHOST}/api/token/create-payer`, {
          oldPayerId: this.payerID
        }, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.getUserData.key}`
          }
        })

        if(res.data.id) {
          this.payers = [...this.payers, res.data]
          this.payerID = res.data.id
          this.payerPublicKey = res.data.publicKey
        }
      }
    },
    mounted() {
      this.getPayers()
    },

    setup() {
      const file = ref(null)
      const fileList = ref([]) // Список файлов для UI
      const handleUpload = ({ file: uploadedFile, onFinish }) => {
        file.value = uploadedFile.file // Сохраняем файл
        fileList.value = [{ id: Date.now(), name: uploadedFile.file.name }] // Для UI
        console.log(file.value)
        onFinish() // Уведомляем Naive UI, что загрузка завершена
      }
      const toast = useToast()
      return { file, handleUpload, toast }
    },
  }
</script>

<style scoped>
  .launch {
    width: 33% !important;
    margin: 0 auto;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    padding: 2%;
    background-color: #191919;
    border-radius: 14px;
    text-align: left;
    filter: drop-shadow(0 0 6px #191919);
  }
  .launchBlock {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .tokenInfo {
    display: flex;
    gap: 20px;
  }
  .tokenText {
    display: flex;
    flex-direction: column;
    width: 70%;
  }
  .tokenText div {
    margin-bottom: 7px;
  }
  .button {
    background-color: #60cb89;
    color: white;
    border-radius: 5px;
    padding: 7px 30px;
    width: fit-content;
    font-size: 16px;
    border: none;
    cursor: pointer;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .upload_photo {
    background: rgba(96, 203, 137, 0.73);
    border-radius: 7px;
    position: relative;
    padding: 6px 15px;
    font-size: 14px;
    width: fit-content;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .upload_input {
    display: none;
  }
  :deep(.n-upload-dragger) {
    padding: 3% !important;
    color: white;
  }
  input {
    background-color: transparent;
    outline: none;
    border: none;
    color: white;
    height: 100%;
    width: 100%;
  }
  .zeroblock-wallets-config {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
  }

  .protrades-wallets-config {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;

    gap: 5px;
  }
  .switch-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .ios-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .ios-switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
  }
  .ios-switch .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;
  }
  .ios-switch .slider:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
  .ios-switch input:checked + .slider {
    background-color: #62bf8f;
  }
  .ios-switch input:checked + .slider:before {
    transform: translateX(20px);
  }
</style>
